import { FormControlLabel, Switch } from '@mui/material'

const SwitchControl = ({ label, checked, onChange }) => (
  <FormControlLabel control={<Switch disabled={!checked} defaultChecked={checked} onChange={onChange} />} label={label} />
)

export default SwitchControl
